// routes
import Router from "./routes";
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import CallingModal from "./components/CallingModal"; // Import CallingModal
import RingingModal from "./components/RingingModal"; // Import RingingModal
import CallWindow from "./components/CallWindow"; // Import CallWindow
import PagerReceivedModal from "./components/PagerReceivedModal"; // Import PagerReceivedModal
import { Toaster } from 'react-hot-toast'; // Import Toaster
import { useLocation } from "react-router-dom"; // Import useLocation
import FullScreenLoader from "./components/FullScreenLoader"; // Import FullScreenLoader
import { useSelector } from "react-redux"; // Import useSelector

function App() {
  const location = useLocation(); // Get current location
  const { isChatStarting } = useSelector((state) => state.app); // Get isChatStarting from Redux

  return (
    <ThemeProvider>
      <ThemeSettings pathname={location.pathname}>
        {" "}
        <Router />{" "}
        {/* Call Modals rendered at the root level */}
        <CallingModal />
        <RingingModal />
        <CallWindow />
        <PagerReceivedModal /> {/* Add PagerReceivedModal here */}
        <Toaster /> {/* Add Toaster here for notifications */}
        <FullScreenLoader open={isChatStarting} message="Preparing your team chat…" /> {/* Full-screen loader */}
      </ThemeSettings>
    </ThemeProvider>
  );
}

export default App;